import { createAction } from '@reduxjs/toolkit';
export const updateDocResource = createAction('documents/saga/update-resource');
